import React from 'react'
import { Route, Switch } from 'react-router-dom'
import CptSearch from '../pages/CptSearch'
import { NotFound } from '../pages/NotFound'
import { ClaimsSearch } from '../pages/ClaimsSearch'
import { EligibilitySearch } from '../pages/EligibilitySearch'
import routes from './paths'

export const Router = () => {
  // This react app's distrobution is pointed to 2 different domains, authorizations.anglehealth.com for the CPT Search and claims.anglehealth.com for the Claims Search Tool.

  const host = window.location.host

  let component

  if (host.includes('authorizations')) {
    component = CptSearch
  } else if (host.includes('claims')) {
    component = ClaimsSearch
  } else if (host.includes('eligibility')) {
    component = EligibilitySearch
  }

  return (
    <Switch>
      <Route path={routes.search} component={component} />
      {/* routes.claims is "/" */}
      <Route exact path={routes.claims} component={component} />
      <Route component={NotFound} />
    </Switch>
  )
}
